

import { useState } from 'react';
import SampleDataViewer from '@/components/mapping/SampleDataViewer';
import MappingInterface from '@/components/mapping/MappingInterface';
import { SampleData } from '@/services/spreadsheetService';
import VendorSelect from '@/components/VendorSelect';
import { Vendor } from '@/types';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const CreateMappingSheet = () => {
  const [sampleData, setSampleData] = useState<SampleData | null>(null);
  const [isDataSectionCollapsed, setIsDataSectionCollapsed] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState<Vendor | null>(null);
  
  const handleDataFetched = (data: SampleData) => {
    setSampleData(data);
  };
  
  const toggleDataSection = () => {
    setIsDataSectionCollapsed(!isDataSectionCollapsed);
  };
  
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4 max-w-full">
        <h1 className="text-2xl font-bold text-center mb-2">Create Mapping Configuration</h1>
        <p className="text-gray-500 text-center mb-8">
          Select a vendor, upload files or connect to Google Sheets, then map supplier attributes to Nestingale attributes
        </p>
        
        {/* Vendor Selection */}
        <div className="mb-6">
          <Card className="max-w-md mx-auto">
            <CardHeader>
              <CardTitle className="text-lg">Select Vendor</CardTitle>
              <CardDescription>
                Choose the vendor to fetch the correct Nestingale attributes
              </CardDescription>
            </CardHeader>
            <CardContent>
              <VendorSelect onVendorSelect={setSelectedVendor} />
            </CardContent>
          </Card>
        </div>
        
        <div className="flex flex-col lg:flex-row gap-4">
          {/* Sample Data Section */}
          <SampleDataViewer 
            sampleData={sampleData} 
            isCollapsed={isDataSectionCollapsed}
            onToggleCollapse={toggleDataSection}
          />
          
          {/* Mappings Section */}
          <MappingInterface 
            sampleData={sampleData} 
            onDataFetched={handleDataFetched}
            isDataSectionCollapsed={isDataSectionCollapsed}
            vendorName={selectedVendor?.name}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateMappingSheet;
